// extracted by mini-css-extract-plugin
module.exports = {"titleBox":"titleBox___2oJqU"};